<template>
  <div v-if="company && menus">
    <div v-if="(!company.enabled || !company.active || (menus.length <= 0 && $route.name != 'Speisekarte') || (!checkOpeningTimes() && $route.name != 'Einstellungen') || (!checkDeliveryTimes() && $route.name != 'Einstellungen'))">
        <b-row class="m-0 mt-2 justify-content-center w-100" >
          <div  class="showcase-invert bg-white shadow m-2" style="min-width: 100%">
            <div class="showcase-header py-4 linear-danger text-white" style="position: relative">
              <h4 class="text-center m-0">Wichtige Meldungen</h4>
            </div>
            <b-row class="p-0 justify-content-center" v-if="company">
              <b-alert class="my-1 mx-3 w-100 text-center" show variant="danger" v-if="!company.enabled">
                Dein Restaurant wurde noch nicht freigegeben, diese Prüfung kann etwas Zeit in Anspruch nehmen.
              </b-alert>
              <b-alert class="my-1 mx-3 w-100 text-center" show variant="success" v-if="menus.length <= 0 && $route.name != 'Speisekarte'">
                Erstelle deine Speisekarte => <span class="custom-nav" @click="$router.push('/menu').catch(err => {})">zur Speisekarte</span> 
              </b-alert>
              <b-alert class="my-1  mx-3 w-100 text-center" show variant="warning" v-if="!company.active">
                Dein Restaurant wird aktuell nicht in der App gelistet => <span class="custom-nav" @click="$router.push('/me?goonline=true').catch(err => {})">Online schalten</span> 
              </b-alert>
              <b-alert class="my-1  mx-3 w-100 text-center" show variant="warning" v-if="!company.contact.mobile">
                Gebe eine Mobilnummer für Onlinebestellungen an => <span class="custom-nav" @click="$router.push('/me?mobilenumber=true').catch(err => {})">Mobilnummer angeben</span> 
              </b-alert>
              <b-alert class="my-1  mx-3 w-100 text-center" show variant="success" v-if="!checkOpeningTimes() && $route.name != 'Einstellungen'">
                Gebe deine Abholzeiten an => <span class="custom-nav" @click="$router.push('/me?opening_times=true').catch(err => {})">zu den Öffnungszeiten</span> 
              </b-alert>
              <b-alert class="my-1  mx-3 w-100 text-center" show variant="success" v-if="!checkDeliveryTimes() && $route.name != 'Einstellungen'">
                Gebe deine Lieferzeiten an => <span class="custom-nav" @click="$router.push('/me?delivery_times=true').catch(err => {})">zu den Öffnungszeiten</span> 
              </b-alert>
            </b-row>
          </div>
        </b-row>
    </div>
  </div>    
</template>

<script>
import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'MessageCenter',
  mixins: [coreData],
  props: {
    name: String,
    img: String,
    description: String,
    distance: String,
    rating: Number,
    id: String,
    init: Boolean
  },
  components: {

  },
  data: () => {
    return {
     
    }
  },
  watch: {
    
  },
  computed: {
    
  },
  mounted(){
    
  },
  methods: {
  
  }
}
</script>

<style lang="scss" >

</style>
